import { maintenanceAPI } from './api';

export const proveedorService = {
  // Listar proveedores
  getProveedores: async () => {
    const response = await maintenanceAPI.get('/proveedores');
    return response.data;
  },

  // Crear proveedor
  createProveedor: async (data: any) => {
    const response = await maintenanceAPI.post('/proveedores', data);
    return response.data;
  },

  // Actualizar proveedor
  updateProveedor: async (id: number, data: any) => {
    const response = await maintenanceAPI.put(`/proveedores/${id}`, data);
    return response.data;
  },

  // Ver detalle de proveedor
  getProveedorDetalle: async (id: number) => {
    const response = await maintenanceAPI.get(`/proveedores/${id}`);
    return response.data;
  },

  // Dashboard de proveedores
  getDashboard: async () => {
    const response = await maintenanceAPI.get('/proveedores/dashboard');
    return response.data;
  },

  // Comparar proveedores para un plan
  compararProveedoresParaPlan: async (items: Array<{ item_catalogo_id: number; cantidad: number }>) => {
    const response = await maintenanceAPI.post('/proveedores/comparar-plan', { items });
    return response.data;
  },

  // Obtener cotizaciones para un item
  getCotizacionesParaItem: async (itemId: number) => {
    const response = await maintenanceAPI.get(`/proveedores/cotizaciones/${itemId}`);
    return response.data;
  },

  // Obtener paquetes para una rutina
  getPaquetesParaRutina: async (rutinaId: number) => {
    const response = await maintenanceAPI.get(`/proveedores/paquetes-rutina/${rutinaId}`);
    return response.data;
  },

  // Marcar proveedor preferido
  marcarProveedorPreferido: async (itemCatalogoId: number, proveedorId: number) => {
    const response = await maintenanceAPI.post(
      '/proveedores/marcar-preferido',
      { item_catalogo_id: itemCatalogoId, proveedor_id: proveedorId }
    );
    return response.data;
  },

  // Paquetes
  getPaquetes: async (proveedorId?: number) => {
    const url = proveedorId
      ? `/paquetes-proveedor?proveedor_id=${proveedorId}`
      : `/paquetes-proveedor`;
    const response = await maintenanceAPI.get(url);
    return response.data;
  },

  createPaquete: async (data: any) => {
    const response = await maintenanceAPI.post('/paquetes-proveedor', data);
    return response.data;
  },

  getPaqueteDetalle: async (id: number) => {
    const response = await maintenanceAPI.get(`/paquetes-proveedor/${id}`);
    return response.data;
  },

  updatePaquete: async (id: number, data: any) => {
    const response = await maintenanceAPI.put(`/paquetes-proveedor/${id}`, data);
    return response.data;
  },

  deletePaquete: async (id: number) => {
    const response = await maintenanceAPI.delete(`/paquetes-proveedor/${id}`);
    return response.data;
  },

  // Cotizaciones (CRUD)
  getCotizaciones: async (params?: { proveedor_id?: number; item_catalogo_id?: number; historico?: number }) => {
    const response = await maintenanceAPI.get('/cotizaciones', { params });
    return response.data;
  },

  createCotizacion: async (data: any) => {
    const response = await maintenanceAPI.post('/cotizaciones', data);
    return response.data;
  },

  updateCotizacion: async (id: number, data: any) => {
    const response = await maintenanceAPI.put(`/cotizaciones/${id}`, data);
    return response.data;
  },

  deleteCotizacion: async (id: number) => {
    const response = await maintenanceAPI.delete(`/cotizaciones/${id}`);
    return response.data;
  },
};
